import { config, gameState } from '@js/state';

var points;
var array;
var divide = false;

var joystickInput = false;

var sliderDrag = false;

var bearDropped = false;

var divisionPoints = [644, 758.6425, 873.285, 987.9275, 1102.57, 1217.2125, 1331.855, 1446.4975, 1561.1399999999999];

export default class TutorialScene extends Phaser.Scene {
  constructor() {
    super({
      key: "TutorialScene",
    });
  }

  preload() {
    // this.load.image('tutorialSceneBG', 'assets/TutorialScreenAssets/tutorialSceneBG.png');
    // this.load.image('checkButton', 'assets/TutorialScreenAssets/checkButton.png');
    // this.load.image('joyStick', 'assets/TutorialScreenAssets/Joystick.png');
    // this.load.image('overlay', 'assets/TutorialScreenAssets/Overlay.png');
    // this.load.image('speechBubble', 'assets/TutorialScreenAssets/Speech Bubble.png');
  }

  create() {
    config.audio.bgaudio.setVolume(0.02);
    config.audio.hintaudio = this.sound.add("hintaudio").setVolume(0.05);
    config.audio.incorrectdropaudio = this.sound.add("incorrectdropaudio").setVolume(0.05);
    config.audio.correctdropaudio = this.sound.add("correctdropaudio").setVolume(0.05);

    for (let i = 1; i <= 4; i++) {
      config.audio["ta" + i] = this.sound.add("ta" + i).setVolume(0.3);
    }

    this.add.sprite(config.width / 2, config.height / 2, "tutorialSceneBG").setDisplaySize(1280, 720);
    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setAlpha(0.6)
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setDisplaySize(1280, 720);
    this.numberLine = this.add
      // .sprite(config.width / 2, config.height - 187, "numberLine")
      .sprite(config.width / 2 + 1, config.height - 188, "numberLine")
      .setScale(0.67)
      .setFrame(0);
    this.speechBubble = this.add
      .sprite(214, 170 + 63, "speechBubble")
      // .setScale(0.67)
      .setAlpha(0)
      .setOrigin(0, 0.1);
    this.qBoard = this.add
      .sprite(214, 190 + 63, "qBoard")
      // .setScale(0.67)
      .setOrigin(0, 1)
      .setAlpha(0);
    this.tutSceneText = this.add
      .sprite(config.width / 2, config.height / 2 + 60, "tutSceneText1")
      .setOrigin(0.5, 0.5)
      .setAlpha(0);

    this.heliHover = this.physics.add.sprite(-200, 363, "heliHoverAnim").setScale(0.67);
    this.anims.create({
      key: "hover",
      frames: this.anims.generateFrameNames("heliHoverAnim", {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: "HOVERINGHC",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: -1,
    });

    this.numberSet0 = this.add.sprite(config.width / 2 + 1, config.height - 161, "numberSet0");

    // this.numberBlackSet0 = this.add
    // .sprite((config.width / 2) + 1 , config.height - 161, "numberBlackSet0");

    // this.tweens.add({
    //   targets: config.audio.heliaudio,
    //   volume: 0.005,
    //   duration: 3000,
    //   onComplete: () => {
    //     //heliaudio.setVolume(0.5);
    //   },
    // });

    this.anims.create({
      key: "drop",
      frames: this.anims.generateFrameNames("heliDropAnim", {
        start: 0,
        end: 359,
        zeroPad: 0,
        prefix: "beardrop",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.heliHover.play("hover");

    this.moveHeli(2000, -200, 644);

    this.time.delayedCall(
      2000,
      function () {
        array[0].setFrame(1);
      },
      [],
      this
    );

    this.time.delayedCall(2500, function () {
      config.audio.ta1.play();
    });

    this.tweens.add({
      targets: this.speechBubble,
      ease: "Quint.easeInOut",
      duration: 800,
      delay: 2500,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      scale: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: true,
      hold: 4000,
      loop: 0,
    });

    this.qBoardAppear(214, 8000, 0, 1, 0, 1);

    this.time.delayedCall(
      7800,
      () => {
        this.tutSceneText.setAlpha(1);
      },
      this
    );

    // this.textAppearAnim(7800);

    // this.time.delayedCall(
    //   11800,
    //   function () {
    //     this.tutSceneText.setTexture("tutSceneText2");
    //   },
    //   [],
    //   this
    // );

    // this.textAppearAnim(12800);

    this.graphics = this.add.graphics();

    this.curve = new Phaser.Curves.Line(new Phaser.Math.Vector2(185, 515), new Phaser.Math.Vector2(1101.5, 515));

    this.linePoints = this.add.group();

    this.curve.draw(this.graphics);

    this.numberLine.setFrame(0);

    array = this.linePoints.getChildren();

    divide = true;

    this.numberLineDivide(8);

    joystickInput = true;

    // array[0].setFrame(2);

    // for (let i = 1; i < array.length; i++) {
    //   array[i].setFrame(2);
    // }

    // this.leftJoystick = this.add.sprite(529,578,'leftJoystick').setScale(1).setOrigin(0).setAlpha(1).setDepth(2);
    // this.rightJoystick = this.add.sprite(559,578  ,'rightJoystick').setScale(1).setOrigin(0).setAlpha(0.1).setDepth(2);

    this.score1 = this.add
      .sprite(935 - 8, 43, "greenCircle")
      .setOrigin(0)
      .setVisible(false);

    this.orangePoint = this.add.sprite(-200, 515, "linePoint").setFrame(1).setScale(0.67);

    this.time.delayedCall(8000, function () {
      config.audio.ta2.play();
    });

    this.time.delayedCall(
      11800,
      function () {
        // this.controlsSlideIn([this.joystick], 800, 633);
        // this.controlsSlideIn(
        //   [this.joystickHolder, this.dropButton],
        //   800,
        //   670
        // );

        this.controlsSlideIn([this.dropUp], 800, 639);

        // this.controlsSlideIn([this.dropUp], 800, 670);

        this.controlsSlideIn([this.leftUp, this.rightUp], 800, 643);

        this.textDisappear(0);

        this.time.delayedCall(
          2500,
          () => {
            this.tutSceneText.setTexture("tutSceneText4");
            this.tutSceneText.setAlpha(1);
          },
          this
        );
        //this.textAppearAnim(2500);
        this.time.delayedCall(3000, function () {
          config.audio.ta3.play();
        });

        for (let i = 0; i < array.length; i++) {
          array[i].setFrame(0);
        }

        this.numberLine.setFrame(0);

        this.sliderBar.destroy();
        this.sliderButton.destroy();
        this.sliderText.setVisible(false);

        // this.checkButton.destroy();

        this.checkButtonRight.setVisible(false);

        this.checkButtonRight.setPosition(config.width / 2 + 80, 670);

        // this.moveHeli(2000, 600, 642);

        // this.qBoardAppear(170, 1, 0, 0.67, 0);
        // this.qBoardAppear(214, 1, 0, 1, 0);
      },
      [],
      this
    );

    this.time.delayedCall(
      14300,
      function () {
        // this.joystick.setInteractive({ cursor: "pointer" });

        this.rightUp.setInteractive({ cursor: "pointer" });

        this.handIcon.setVisible(true);
      },
      [],
      this
    );

    //start

    this.sliderBar = this.add
      .sprite(config.width / 2 - 60, 800, "sliderBar")
      .setVisible(false)
      .setScale(0.67);

    this.sliderButtonGhost = this.add
      .sprite(config.width / 2 - 155, 800, "sliderButton")
      .setVisible(false)
      .setScale(0.67)
      .setAlpha(0.6);

    this.sliderButton = this.add
      .sprite(config.width / 2 - 155, 800, "sliderButton")
      .setVisible(false)
      .setScale(0.67)
      .setInteractive({
        cursor: "pointer",
      });

    this.checkConfetti = this.add.sprite(config.width / 2 + 75, 680, "checkConfettiAnim");
    this.anims.create({
      key: "confetti",
      frames: this.anims.generateFrameNames("checkConfettiAnim", {
        start: 0,
        end: 47,
        zeroPad: 0,
        prefix: "checkconfetti",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.checkButtonRight = this.add
      .sprite(config.width / 2 + 150, 650, "checkRightAnim")
      .setScale(0.67)
      .setVisible(false);

    this.anims.create({
      key: "correct",
      frames: this.anims.generateFrameNames("checkRightAnim", {
        start: 1,
        end: 32,
        zeroPad: 0,
        prefix: "CHECK RIGHT",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.arrows = this.add
      .sprite(config.width / 2 - 30, 650, "arrows")
      .setVisible(false)
      .setScale(0.67);

    this.arrowAnim = this.tweens.add({
      targets: this.arrows,
      ease: "Power1",
      duration: 1000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      loop: -1,
      paused: true,
    });

    this.sliderText = this.add
      .text(this.sliderButton.x, this.sliderButton.y, gameState.value, {
        fontFamily: "font1",
        fontSize: "20px",
        fill: "000000",
      })
      .setOrigin(0.5, 0.5);

    this.dropButton = this.add.sprite(config.width / 2 + 80, 800, "dropButtonAnim").setScale(0.67);

    this.dropButton = this.add.sprite(config.width / 2 + 80, 800, "dropButtonAnim").setScale(0.67);

    // this.dropUp = this.add.sprite(666,630, "dropUp").setOrigin(0);
    // this.dropDown = this.add.sprite(666,634, "dropDown").setOrigin(0).setVisible(false);

    // this.leftUp = this.add.sprite(493,634, "leftUp").setOrigin(0);
    // this.leftDown = this.add.sprite(493,638, "leftDown").setOrigin(0).setVisible(false);

    // this.rightUp = this.add.sprite(568,634, "rightUp").setOrigin(0);
    // this.rightDown = this.add.sprite(568,638, "rightDown").setOrigin(0).setVisible(false);

    this.dropUp = this.add.sprite(669, 800, "dropUp").setOrigin(0);
    this.dropDown = this.add.sprite(669, 643, "dropDown").setOrigin(0).setVisible(false);

    this.leftUp = this.add.sprite(493, 800, "leftUp").setOrigin(0);
    this.leftDown = this.add.sprite(493, 647, "leftDown").setOrigin(0).setVisible(false);

    this.rightUp = this.add.sprite(568, 800, "rightUp").setOrigin(0);
    this.rightDown = this.add.sprite(568, 647, "rightDown").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "breatheDrop",
      frames: this.anims.generateFrameNames("dropButtonAnim", {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: "DROP Button breathig",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.handIcon = this.add.sprite(625, 680, "handIcon").setVisible(false).setScale(0.67).setVisible(false);

    this.tweens.add({
      targets: this.handIcon,
      duration: 800,
      ease: "easeInOutSine",
      // delay: 500,
      yoyo: false,
      // x: {from:575, to:611},
      // y: {from:630, to:640},
      scale: { from: 0.67, to: 0.5 },
      loop: -1,
    });

    //

    this.rightUp.on(
      "pointerdown",
      function (pointer) {
        joystickInput = true;

        this.textDisappear(0);

        this.qBoardAppear(644 - 430, 1, 1, 0, 1, 0);
      },
      this
    );

    this.rightUp.on(
      "pointerup",
      function (pointer) {
        this.toggleButton(this.rightUp, this.rightDown, false);

        this.moveHeli(5000, 644, 1101);

        this.time.delayedCall(
          80,
          function () {
            // this.joystick.removeInteractive();

            this.rightUp.removeInteractive();

            this.handIcon.setVisible(false);
          },
          [],
          this
        );

        this.time.delayedCall(
          5000,
          function () {
            this.toggleButton(this.rightDown, this.rightUp, false);
            this.qBoardAppear(1101 - 430, 1, 0, 1, 0, 1);
            // this.dropButton.setInteractive({ cursor: "pointer" });
            // this.dropButton.play("breatheDrop");

            this.toggleButton(this.dropDown, this.dropUp, true);

            array[4].setFrame(1);

            this.tutSceneText.setTexture("tutSceneText5");
            this.tutSceneText.setAlpha(1);

            this.time.delayedCall(200, function () {
              config.audio.ta4.play();
            });
            //this.textAppearAnim(0);
          },
          [],
          this
        );
      },
      this
    );

    //

    this.dropUp.on(
      "pointerup",
      function (pointer) {
        config.audio.correctdropaudio.play();

        this.textDisappear(0);

        bearDropped = true;
        for (let i = 0; i < 5; i++) {
          array[i].setFrame(3);
        }

        this.toggleButton(this.dropUp, this.dropDown, false);

        this.dropDown.setVisible(false);

        joystickInput = false;
        // this.dropButton.stop("breatheDrop");

        // this.dropButton.setVisible(false);

        this.overlay.destroy();

        this.score1.setVisible(true);

        this.qBoardAppear(1101 - 430, 1, 1, 0, 1, 0);

        this.numberSet0.setTexture("numberBlackSet0");

        this.numberLine.setFrame(3);

        for (let i = 0; i < array.length; i++) {
          array[i].setFrame(3);
        }

        array[4].setFrame(2);

        this.checkButtonRight.setVisible(true);

        this.checkButtonRight.play("correct");

        this.checkConfetti.play("confetti");

        this.heliHover.setTexture("heliDropAnim");
        this.heliHover.play("drop");

        // this.time.delayedCall(
        //   3000,
        //   function () {
        //     this.tweens.add({
        //       targets: config.audio.heliaudio,
        //       volume: 0,
        //       duration: 3000,
        //       onComplete: () => {},
        //     });
        //   },
        //   [],
        //   this
        // );

        this.time.delayedCall(
          7000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            this.cameras.main.fadeIn(2000, 255, 255, 255);
            this.scene.stop("TutorialScene");
            this.scene.start("GameScene");
          },
          this
        );
      },
      this
    );
  }

  toggleButton(target, targetpair, allowselectionfornew) {
    target.setVisible(false).removeInteractive();
    targetpair.setVisible(true).removeInteractive();

    if (allowselectionfornew) {
      targetpair.setInteractive({ cursor: "pointer" });
    }
  }

  /*Custom functions*/

  colorchange() {
    // console.log(divisionPoints);
    // console.log(this.heliHover.x);

    for (let i = 0; i < 5; i++) {
      array[i].setFrame(0);
    }
    for (var p = 0; p < 5; p++) {
      if (this.heliHover.x - 20 < divisionPoints[p] && this.heliHover.x + 20 > divisionPoints[p]) {
        array[p].setFrame(1);
      }
    }
  }

  numberLineDivide(divisions) {
    points = this.curve.getPoints(divisions);
    // console.log(points);

    for (var i = 0; i < points.length; i++) {
      var x = this.add.sprite(points[i].x, points[i].y, "linePoint").setFrame(0).setScale(0.67);
      this.linePoints.add(x);
      // console.log(this.linePoints);
    }
  }

  controlsSlideIn(targets, start, end) {
    this.tweens.add({
      targets: targets,
      ease: "Sine.easeInOut",
      duration: 800,
      y: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
    });
  }

  moveHeli(durationVal, start, end) {
    this.tweens.add({
      targets: this.heliHover,
      ease: "Sine.easeInOut",
      duration: durationVal,
      x: {
        getStart: () => start,
        getEnd: () => end,
      },
      yoyo: false,
      loop: 0,
      onStart: () => {
        config.audio.heliaudio.setLoop(true).setVolume(0.005).play();
      },
      onComplete: () => {
        this.tweens.add({
          targets: config.audio.heliaudio,
          ease: "Linear",
          volume: 0,
          duration: 200,
          onComplete: () => {
            config.audio.heliaudio.stop();
          },
        });
      },
    });

    this.tweens.add({
      targets: this.qBoard,
      ease: "Sine.easeInOut",
      duration: durationVal,
      x: {
        getStart: () => start - 430,
        getEnd: () => end - 430,
      },
      yoyo: false,
      loop: 0,
    });
  }

  textDisappear(delay) {
    this.tweens.add({
      targets: this.tutSceneText,
      ease: "Linear",
      duration: 500,
      delay: delay,
      alpha: 0,
    });
  }

  textAppearAnim(delay) {
    this.tweens.add({
      targets: this.tutSceneText,
      ease: "Quint.easeInOut",
      duration: 800,
      delay: delay,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      scale: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: true,
      hold: 2000,
      loop: 0,
    });
  }

  qBoardAppear(newPos, delayVal, alphaStart, alphaEnd, scaleStart, scaleEnd) {
    this.qBoard.x = newPos;

    this.tweens.add({
      targets: this.qBoard,
      ease: "Quint.easeInOut",
      duration: 800,
      delay: delayVal,
      alpha: {
        getStart: () => alphaStart,
        getEnd: () => alphaEnd,
      },
      scale: {
        getStart: () => scaleStart,
        getEnd: () => scaleEnd,
      },

      yoyo: false,
      loop: 0,
    });
  }

  panDisappearAnim() {}

  /*--------------------------------------*/

  update() {
    if (!bearDropped) {
      this.colorchange();
    }
  }
}
